import React from 'react';
import { Input, Button, CheckboxTable } from 'components';
import { ServiceService } from 'services';
import { Globals, Constants } from 'utils';
import { ServiceArea } from 'types';

/**
 * Los timers de PREPARATION y REVISION se guardan en el backend SIEMPRE en SEGUNDOS
 * (mismos nombres de campo: response_time, timeout). En este formulario se muestran
 * y editan en MINUTOS para mejor UX, convirtiendo en la frontera (cargar/guardar).
 */
const secondsToMinutes = (seconds: any): string => {
  const value = Number(seconds) || 0;
  if (!value) return '';
  return String(Math.round((value / 60) * 100) / 100);
};

const minutesToSeconds = (minutes: any): number => {
  const value = Number(minutes) || 0;
  return Math.round(value * 60);
};

interface Props {
  title?: string;
  onClose?: any;
  item?: any;
}

class CreateService extends React.Component<Props> {
  state = {
    form: {
      price: '',
      price_to_external_lawyer: '',
      minimum_time: '',
      response_time: '',
      timeout: '',
      fee: '',
      max_quantity: '',
    },
    areas: [] as ServiceArea[],
  };

  componentDidMount() {
    if (this.props.item) {
      // Para PREPARATION y REVISION, el backend guarda response_time/timeout en SEGUNDOS.
      // Se convierten a MINUTOS solo para mostrarlos en este formulario.
      const isTimeInMinutesService =
        this.props.item?.id == Constants.SERVICES.PREPARATION ||
        this.props.item?.id == Constants.SERVICES.REVISION;

      this.setState({
        form: {
          ...this.state.form,
          price: this.props.item?.price || '',
          minimum_time: this.props.item?.minimum_time || '',
          response_time: isTimeInMinutesService
            ? secondsToMinutes(this.props.item?.response_time)
            : this.props.item?.response_time || '',
          timeout: isTimeInMinutesService
            ? secondsToMinutes(this.props.item?.timeout)
            : this.props.item?.timeout || '',
          fee: this.props.item?.fee || '',
          price_to_external_lawyer: this.props.item?.price_to_external_lawyer || '',
          max_quantity: this.props.item?.max_quantity || '',
        },
      });

      this.load();
    }
  }

  load = async () => {
    const res: any = await ServiceService.admin.getPrices({
      service_id: this.props.item?.id,
    });

    let areas: ServiceArea[] = res.service || [];

    for (let i = 0; i < areas.length; i++) {
      if (!areas[i].documents) continue;
      for (let j = 0; j < areas[i].documents.length; j++) {
        const item = (areas[i].documents[j] as any).price;

        areas[i].documents[j].price = '';
        areas[i].documents[j].fee = '';

        if (item) {
          areas[i].documents[j].price = item.price || '';
          areas[i].documents[j].fee = item.fee !== null && item.fee !== undefined ? item.fee : '';
        }
      }
    }

    this.setState({
      areas,
    });
  };

  submit = async (e: any) => {
    e.preventDefault();

    if (this.props.item?.id == Constants.SERVICES.PREPARATION) {
      if (!this.state.form.response_time) {
        Globals.showError('Por favor, ingrese el tiempo solicitudes respuesta');
        return;
      }

      // if (!this.state.form.minimum_time) {
      //   Globals.showError(
      //     'Por favor, ingrese el tiempo mínimo de asignación interna',
      //   );
      //   return;
      // }

      if (!this.state.form.timeout) {
        Globals.showError('Por favor, ingrese el tiempo agotado');
        return;
      }

      for (let i = 0; i < this.state.areas.length; i++) {
        const area = this.state.areas[i];
        const items_pending = area.documents.filter(
          (i) => i.fee === '' || i.fee === null || i.fee === undefined,
        ).length;

        if (items_pending > 0) {
          Globals.showError('Por favor, ingrese el porcentaje de comisión de todos los documentos');
          return;
        }
      }
    }

    if (this.props.item?.id == Constants.SERVICES.REVISION) {
      for (let i = 0; i < this.state.areas.length; i++) {
        const area = this.state.areas[i];
        let items_pending = area.documents.filter(
          (i) => i.fee === '' || i.fee === null || i.fee === undefined,
        ).length;

        if (items_pending > 0) {
          Globals.showError('Por favor, ingrese el porcentaje de comisión de todos los documentos');
          return;
        }

        // items_pending = area.documents.filter((i) => !i.price).length;

        // if (items_pending > 0) {
        //   Globals.showError(
        //     'Por favor, ingrese el costo de todos los documentos',
        //   );
        //   return;
        // }
      }
    }

    if (this.props.item?.id === Constants.SERVICES.CHAT) {
      if (!this.state.form.timeout) {
        Globals.showError('Por favor, ingrese el tiempo máximo de chat');
        return;
      }

      if (!this.state.form.max_quantity) {
        Globals.showError('Por favor, ingrese el número máximo de chats simultaneaos');
        return;
      }

      if (!this.state.form.price_to_external_lawyer) {
        Globals.showError(
          'Por favor, ingrese el monto a pagar a abogado externo por resolver caso',
        );
        return;
      }

      if (!this.state.form.price) {
        Globals.showError('Por favor, ingrese el monto a pagar al agotar el uso');
        return;
      }
    }

    if (this.props.item?.id === Constants.SERVICES.CALL) {
      if (!this.state.form.max_quantity) {
        Globals.showError(
          'Por favor, ingrese el número máximo de llamadas al mes que podrá atender el abogado',
        );
        return;
      }

      if (!this.state.form.price) {
        Globals.showError('Por favor, ingrese el monto a pagar al agotar el uso');
        return;
      }
    }

    let documents: any[] = [];

    for (let i = 0; i < this.state.areas.length; i++) {
      if (!this.state.areas[i].documents) continue;
      documents = [
        ...documents,
        ...this.state.areas[i].documents.map((doc) => ({
          document_id: doc.id,
          price: doc.price,
          fee: doc.fee,
        })),
      ];
    }

    // Para PREPARATION y REVISION, convertir de MINUTOS (lo que el admin ingresó)
    // a SEGUNDOS (lo que espera y guarda el backend).
    const isTimeInMinutesService =
      this.props.item?.id == Constants.SERVICES.PREPARATION ||
      this.props.item?.id == Constants.SERVICES.REVISION;

    const payload: any = {
      service_id: this.props.item?.id,
      ...this.state.form,
      prices: JSON.stringify(documents),
    };

    if (isTimeInMinutesService) {
      payload.response_time = minutesToSeconds(this.state.form.response_time);
      payload.timeout = minutesToSeconds(this.state.form.timeout);
    }

    await ServiceService.admin.update(payload);
    Globals.showSuccess('Se ha modificado el servicio correctamente');
    this.props.onClose();
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  changeDocumentPrice = (e: any, area_index: number, document_index: number) => {
    let areas = [...this.state.areas];
    (areas[area_index].documents[document_index] as any)[e.target.name] = e.target.value;
    this.setState({ areas });
  };

  render() {
    return (
      <div id='modal-create-service'>
        <form onSubmit={this.submit}>
          {this.props.item?.id == Constants.SERVICES.PREPARATION ? (
            <div className='container-inputs'>
              <p className='title-create'>Configuración de tiempo (minutos)</p>
              <div className='row row-config'>
                <div className='col-6'>
                  <p>Tiempo máximo para colocar status disponible al abogado (en minutos)</p>
                </div>
                <div className='col-6'>
                  <Input
                    type='number'
                    color='white'
                    value={this.state.form.response_time}
                    name='response_time'
                    placeholder='0'
                    onChange={this.change}
                  />
                </div>
                <div className='col-6'>
                  <p>Tiempo máximo para contratar servicio del cliente (en minutos)</p>
                </div>
                <div className='col-6'>
                  <Input
                    type='number'
                    color='white'
                    value={this.state.form.timeout}
                    name='timeout'
                    placeholder='0'
                    onChange={this.change}
                  />
                </div>
              </div>
              <AreasContainer
                areas={this.state.areas}
                item={this.props.item}
                changeDocumentPrice={(e: any, index: number, _index: number) =>
                  this.changeDocumentPrice(e, index, _index)
                }
              />
            </div>
          ) : this.props.item?.id == Constants.SERVICES.REVISION ? (
            <div className='container-inputs'>
              <p className='subtitle'>Configuración de tiempo (minutos)</p>
              <div className='row'>
                <div className='col-6'>
                  <p>Tiempo máximo del equipo interno para tomar el caso</p>
                  <small style={{ opacity: 0.7 }}>
                    En búsquedas públicas (marketplace), este mismo tiempo se usa como plazo para
                    que el cliente elija entre los abogados postulados.
                  </small>
                </div>
                <div className='col-1'>
                  <Input
                    type='number'
                    color='white'
                    value={this.state.form.timeout}
                    name='timeout'
                    placeholder='0'
                    onChange={this.change}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-6'>
                  <p>Tiempo adicional para que abogados externos tomen el caso</p>
                  <small style={{ opacity: 0.7 }}>
                    En búsquedas públicas (marketplace), este mismo tiempo se usa como plazo para
                    que los abogados externos se postulen.
                  </small>
                </div>
                <div className='col-1'>
                  <Input
                    type='number'
                    color='white'
                    value={this.state.form.response_time}
                    name='response_time'
                    placeholder='0'
                    onChange={this.change}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-3'>
                  <p>Monto a pagar al agotar el uso ($)</p>
                </div>
                <div className='col-1'>
                  <Input
                    type='number'
                    color='white'
                    value={this.state.form.price}
                    name='price'
                    placeholder='0'
                    onChange={this.change}
                  />
                </div>
              </div>
              <AreasContainer
                areas={this.state.areas}
                item={this.props.item}
                changeDocumentPrice={(e: any, index: number, _index: number) =>
                  this.changeDocumentPrice(e, index, _index)
                }
              />
            </div>
          ) : this.props.item?.id == Constants.SERVICES.CHAT ? (
            <div className='container-inputs chat'>
              <div className='row justify-content-between'>
                <div className='col-8'>
                  <p className='subtitle'>
                    Configuración de tiempo (minutos) chat abogado - abogado
                  </p>
                  <p>Tiempo máximo para aceptar la solicitud los abogados internos</p>
                </div>
                <div className='col-2 align-self-end'>
                  <Input
                    type='number'
                    color='white'
                    value={this.state.form.timeout}
                    name='timeout'
                    placeholder='0'
                    onChange={this.change}
                  />
                </div>
              </div>
              <div className='row justify-content-between mt-3'>
                <div className='col-8'>
                  <p className='subtitle'>Configuración de cantidad</p>
                  <p>Número máximo de chats que puede atender simultáneamente</p>
                </div>
                <div className='col-2 align-self-end'>
                  <Input
                    type='number'
                    color='white'
                    value={this.state.form.max_quantity}
                    name='max_quantity'
                    placeholder='0'
                    onChange={this.change}
                  />
                </div>
              </div>
              <div className='row justify-content-between mt-3'>
                <div className='col-8'>
                  <p className='subtitle'>Configuración de tarifa de solución por abogado($)</p>
                  <p>Monto a abogado externo por resolver caso</p>
                </div>
                <div className='col-2 align-self-end'>
                  <Input
                    type='number'
                    color='white'
                    value={this.state.form.price_to_external_lawyer}
                    name='price_to_external_lawyer'
                    placeholder='0'
                    onChange={this.change}
                  />
                </div>
              </div>
              <div className='row justify-content-between mt-3'>
                <div className='col-8'>
                  <p className='subtitle'>Monto a pagar al agotar el uso ($)</p>
                </div>
                <div className='col-2 align-self-end'>
                  <Input
                    type='number'
                    color='white'
                    value={this.state.form.price}
                    name='price'
                    placeholder='0'
                    onChange={this.change}
                  />
                </div>
              </div>
            </div>
          ) : this.props.item?.id == Constants.SERVICES.CALL ? (
            <div className='container-inputs chat'>
              <p className='subtitle'>Configuración de cantidad</p>
              <div className='row justify-content-between mt-3'>
                <div className='col-8'>
                  <p>Número máximo de llamadas al mes que podrá atender el abogado</p>
                </div>
                <div className='col-3 align-self-end'>
                  <Input
                    type='number'
                    color='white'
                    value={this.state.form.max_quantity}
                    name='max_quantity'
                    placeholder='0'
                    onChange={this.change}
                  />
                </div>
              </div>
              <div className='row justify-content-between mt-3'>
                <div className='col-8'>
                  <p>Monto a pagar al agotar usos</p>
                </div>
                <div className='col-3 align-self-end'>
                  <Input
                    type='number'
                    color='white'
                    value={this.state.form.price}
                    name='price'
                    placeholder='0'
                    onChange={this.change}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className='container-inputs'>
              <div className='row'>
                <div className='col-md-12'>
                  <Input
                    type='decimal'
                    color='white'
                    value={this.state.form.price}
                    name='price'
                    label='Precio'
                    placeholder='0'
                    className='price-input'
                    onChange={this.change}
                  />
                </div>
              </div>
            </div>
          )}
          <div className='text-center'>
            <Button type='submit'>Guardar</Button>
          </div>
        </form>
      </div>
    );
  }
}

export default CreateService;

const AreasContainer = (props: any) => (
  <>
    {props.areas.map((item: any, index: number) => (
      <div className='container-area' key={item.id}>
        <p className='area-title'>{item.name}</p>
        {item.documents.map((_document: any, _index: number) => (
          <div className='row' style={{ marginTop: '10px' }} key={_document.id}>
            <div className={`col-${props.item?.id == Constants.SERVICES.PREPARATION ? '8' : '6'}`}>
              <p className='document-name'>{_document.name}</p>
            </div>
            {/* {props.item?.id == Constants.SERVICES.REVISION && (
              <div className="col-2">
                <Input
                  type="decimal"
                  color="white"
                  value={_document.price}
                  placeholder="0"
                  name="price"
                  label={_index == 0 ? 'Costo Servicio ($)' : ''}
                  onChange={(e: any) =>
                    props.changeDocumentPrice(e, index, _index)
                  }
                />
              </div>
            )} */}
            <div className='col-2'>
              <Input
                type='percentage'
                color='white'
                value={_document.fee}
                placeholder='0'
                name='fee'
                label={_index == 0 ? 'Fee (Precio fijo)' : ''}
                onChange={(e: any) => props.changeDocumentPrice(e, index, _index)}
              />
            </div>
            {/* <div className="col-2">
              <Input
                type="number"
                color="white"
                placeholder="0"
                disabled={true}
                value={100 - _document.fee}
                label={_index == 0 ? 'Monto Abogado (%)' : ''}
                onChange={() => {}}
              />
            </div> */}
          </div>
        ))}
      </div>
    ))}
  </>
);
